import { useCallback } from "react";
import { useLocation } from "react-router";
import TagManager from "react-gtm-module";
import { GTM_IDS } from "constants/googleTagManager";

export const useGoogleTagManager = () => {
  const { pathname } = useLocation();

  const initializeGoogleTagManager = useCallback(() => {
    if (!pathname) return;

    const tagManagerArgs = {
      gtmId: GTM_IDS.DEFAULT
    };

    TagManager.initialize(tagManagerArgs);
  }, [pathname]);

  return {
    initializeGoogleTagManager
  };
};
